<mat-drawer-container class="container" autosize>
    <mat-drawer #drawer (openedChange)="onOpenedChange($event)" class="sidenav" mode="push" opened>
        <p class="drawer-title">{{strings["warningsAndErrors"]}}</p>
        <p class="drawer-subtitle">{{integrationDisplayName}}</p>
        <app-virtualized-date-list
            [dates]="dates"
            [selectedDate]="date"
            [ariaLabel]="strings['warningsAndErrors']"
            (dateSelected)="selectDate($event)">
        </app-virtualized-date-list>
    </mat-drawer>

    <div class="sidenav-content">
        <button mat-button class="sidenav-toggle-open" (click)="drawer.toggle()">
            <img  src="../../assets/images/icons/FillchevronRight.svg" [ngClass]="{ 'chevron-left': isDrawerOpen==false, 'chevron-right': isDrawerOpen==true }">
        </button>
        <div class="openView">
        <div *ngIf="hasData" class="log-text">
            <div *ngIf="showNoLogs">{{strings["noErrors"]}} </div>
            <p *ngFor="let e of errors">
                {{e}}
            </p>
        </div>
        <div class="exports" *ngIf="saveIconShow">
            <div>JSON: </div>
            <img class="json-download-icon" src="../../assets/images/icons/FilldownloadFile.svg" 
                (click)="downloadJson()">
        </div>
    </div>
    </div>
</mat-drawer-container>
